import classNames from "classnames";
import React, { FunctionComponent, useMemo } from "react";
import { useIntl } from "react-intl";
import useCustomizationContext from "../../../../hooks/useCustomizationContext";
import { ReactComponent as IconRedo } from "../../../../icons/redo.svg";
import { ReactComponent as IconUndo } from "../../../../icons/undo.svg";
import "./style.scss";

interface Props {
  onCancel?: () => void;
  onValidate?: () => void;
  validateButton?: {
    disabled: boolean;
    label: string;
    type: "error" | "primary-darker";
  };
  withUndoRedo?: boolean;
}

const UndoRedo: FunctionComponent<Props> = () => {
  const { dispatch, undoRedo } = useCustomizationContext();
  const intl = useIntl();

  const isVisible = useMemo(() => {
    return undoRedo.undoStack.length > 0 || undoRedo.redoStack.length > 0;
  }, [undoRedo]);

  return (
    <div
      className={classNames("UndoRedo", {
        "UndoRedo--hidden": !isVisible,
      })}
    >
      <button
        className="UndoRedo-item"
        disabled={undoRedo.undoStack.length === 0}
        onClick={() => dispatch({ type: "undoRedo", way: "undo" })}
        title={intl.formatMessage({ id: "kustom_undo" })}
      >
        <IconUndo />
      </button>

      <div className="UndoRedo-separator" />

      <button
        className="UndoRedo-item"
        disabled={undoRedo.redoStack.length === 0}
        onClick={() => dispatch({ type: "undoRedo", way: "redo" })}
        title={intl.formatMessage({ id: "kustom_redo" })}
      >
        <IconRedo />
      </button>
    </div>
  );
};

export default UndoRedo;
